// extracted by mini-css-extract-plugin
module.exports = {"conteiner":"FormRegisterOne_conteiner__2vqnZ"};